import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20dynamic%20manga%20comic%20illustration%20wallpaper%2C%20colorful%20action%20scenes%20with%20motion%20lines%2C%20warm%20orange%20red%20and%20golden%20gradient%20background%2C%20abstract%20comic%20halftone%20dots%20pattern%2C%20energetic%20and%20exciting%20atmosphere%2C%20Japanese%20manga%20inspired%20art%20style&width=1800&height=900&seq=hero-bg-51manhua&orientation=landscape"
          alt="51漫画 - 海量漫画资源免费下载"
          className="w-full h-full object-cover object-top"
          title="51漫画免费下载 - 漫画资源大全"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-2xl">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6">
              海量漫画资源
              <br />
              <span className="text-primary-400">免费下载</span> 随时随地畅享阅读
            </h1>
            <p className="text-base md:text-lg text-white/80 leading-relaxed mb-6 md:mb-8 max-w-lg">
              51漫画提供全网最全漫画资源免费下载，支持全集离线阅读，手机客户端一键安装。热血、恋爱、搞笑、冒险等十二大分类，满足你的所有漫画需求。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#download"
                className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line mr-2" />
                免费下载APP
              </a>
              <Link
                to="/category/rexue"
                className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-medium hover:bg-white/20 transition-all whitespace-nowrap"
              >
                浏览漫画库
                <i className="ri-arrow-right-line ml-2" />
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-3 md:gap-4 mt-8 md:mt-10">
              <div className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
                <i className="ri-checkbox-circle-fill text-green-400" />
                <span>完全免费</span>
              </div>
              <div className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
                <i className="ri-checkbox-circle-fill text-green-400" />
                <span>离线阅读</span>
              </div>
              <div className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
                <i className="ri-checkbox-circle-fill text-green-400" />
                <span>高清画质</span>
              </div>
              <div className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
                <i className="ri-checkbox-circle-fill text-green-400" />
                <span>每日更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 hidden md:block">
        <div className="max-w-[1400px] mx-auto px-6 pb-6">
          <div className="flex items-center gap-3 flex-wrap">
            {categories.slice(0, 8).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 bg-white/10 backdrop-blur-sm text-white/90 rounded-full text-sm hover:bg-white/20 transition-all whitespace-nowrap border border-white/20"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}